<template>
  <div id="contenedor-eliminar-contrato-garantia">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Garantía </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar la garantía? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarGarantia"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixGarantiasContratos from './mixGarantiasContrato';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarGarantiaContrato',
  mixins: [mixGarantiasContratos],
  props: {
    garantiaEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
